import { Button } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { useSelector } from "react-redux";

const CoreBack = () => {
  const navigate = useNavigate();
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  return (
    <Button
      style={{ color: colorPrimary }}
      onClick={() => navigate(-1)}
      className="w-1/12 me-4"
    >
      <ChevronLeftIcon /> {t("Back")}
    </Button>
  );
};

export default CoreBack;
